import _ from 'lodash';
import fastCompareIsEqual from 'react-fast-compare';

class PerformanceUtils {

  clone(object) {
    if (object)
      return JSON.parse(JSON.stringify(object));
  }

  objectToArray(object = {}) {
    let result = [];
    for (let index in object) result.push(object[index]);
    return result;
  }

  arrayToObject(array = [], key = 'id') {
    let result = {};
    array.forEach(item => {
      result[item[key]] = item;
    });
    return result;
  }

  editOrAdd(document, collection = [], key = 'id') {
    let found = false;
    let result = collection.map(existingData => {
      if (document[key] === existingData[key]) {
        found = true;
        return document;
      }
      return existingData;
    });

    if (!found) result = [document, ...collection];

    return result;
  }

  removeKey(data = {}, targetKey) {
    return Object.keys(data).reduce((result, key) => {
      if (key !== targetKey) {
        result[key] = data[key];
      }
      return result;
    }, {});
  }

  removeFromArray(document, collection = [], key = 'id') {
    return collection.filter(d => {
      return d[key] !== document[key];
    });
  }

  orderById(data, field = 'id') {
    let result = {};
    data.forEach(elem => {
      result[elem[field]] = elem;
    });
    return result;
  }

  sortBy(data = [], fields = ['date'], reverse = true) {
    let sorted = _.sortBy(data, fields);
    if (reverse) sorted = _.reverse(sorted);
    return sorted;
  }

  capitalizeFirstLetter(string = '') {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  capitalize(string = '') {
    return string
      .split(' ')
      .map(this.capitalizeFirstLetter)
      .join(' ');
  }

  isEqual(foo, bar) {
    return fastCompareIsEqual(foo, bar);
  }

  existsInArray(document, array, compareIndex = 'id') {
    let filtered = array.filter(item => item[compareIndex] === document.id);
    return filtered.length > 0;
  }

  getQueryParams(query) {
    let result = {};

    query = query.replace('?', '');
    let split = query.split('&');

    split.forEach(query => {
      let split2 = query.split('=');
      if (split2.length === 2) {
        let key = split2[0];
        result[key] = split2[1];
      }
    });

    return result;
  }
}

export default new PerformanceUtils();
